module.exports = __webpack_public_path__ + "img/Over Tight Setting.7bc2a1b2.png";